<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="产品库存详情" width="1000" @close="close">
      <div>
        <el-table
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="small"
        >
          <el-table-column
              header-align="center"
              label="仓库名称"
              min-width="100"
              prop="WarehouseName"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="库存总数"
              min-width="100"
              prop="AllotShippingQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="海外仓调拨在途量"
              min-width="80"
              prop="HwcInTransitQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="未发货数量"
              min-width="80"
              prop="WaitingQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="调拨在途"
              min-width="80"
              prop="AllotShippingQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="采购在途数量"
              min-width="80"
              prop="ShippingQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="可用库存量"
              min-width="80"
              prop="AvailableStockQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="fba未发货量"
              min-width="80"
              prop="FbaWaitingQuantity"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="分仓调拨未发货量"
              min-width="80"
              prop="TransferWarehouseQuantity"
          ></el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </el-dialog>
  </div>
</template>
<script >
import {
  ElTable, ElDialog,
  ElTableColumn, ElPagination
} from "element-plus";
import http from "@/utils/requset";
export default {
  name: "stockInfo",
  components: {
    ElTable,ElDialog,
    ElTableColumn,ElPagination
  },
  data(){
    return{
      dialogTableVisible:false,
      materialNo:'',
      tableData:[],
      currentPage:1,
      pageSize:10,
      pageTotal:0,
    }
  },
  methods:{
    open(data){
      this.tableData = []
      this.dialogTableVisible = true
      this.currentPage = 1
      this.materialNo = data
      this.getStock()
    },
    close(){
      console.log("close")
      this.dialogTableVisible = false
      this.$emit('closeEdit')
    },
    getStock(){
      http.get('/commodity/goodsStock',{materialNo:this.materialNo,PageNumber:this.currentPage,PageSize:this.pageSize}).then(res=>{
        this.tableData = res.Data.data
        this.pageTotal = res.Data.count
      }).catch(err=>{
        console.log(err)
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getStock();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getStock();
    },
  }

}
</script>
<style scoped>

</style>